import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu-button",
  "use": "menu-button-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu-button\"><path fill-rule=\"evenodd\" d=\"M11 7.5a1 1 0 0 1 1 1v4.47l1.21.13 4.94 2.19c.53.24.85.77.85 1.35V21c-.03.82-.68 1.47-1.5 1.5H11c-.38 0-.74-.15-1-.43l-4.9-4.2.74-.77c.19-.21.46-.32.74-.32h.22L10 18.5v-10a1 1 0 0 1 1-1ZM5 3h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-6v-2h6V5H5v5h4v2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol